import { Component, OnInit } from '@angular/core';
import { menuPermissions, Session } from "../../../services/session.service";
import {ConnectionService} from "../../../services/connection.service";
import { environment } from "../../../../environments/environment";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  public currentUser;
  public organizationInfo;
  public canShowMenu: menuPermissions;
  public online = true;
  isEvaluatorActingForAccreditor: boolean = false;
  isFaculty: boolean = false;

  isStaging: boolean = environment.production === false;
  constructor(private session:Session, private connectionService: ConnectionService) { }

  ngOnInit() {
    this.isEvaluatorActingForAccreditor = this.session.isEvaluatorWorkingForOtherInstitution();
    this.isFaculty = this.session.isFaculty();
    this.currentUser = this.session.getUser();
    this.canShowMenu = this.session.getPermissionToShow;
    this.session.getOrganizationInfo()
      .then((organizationInfo) => {
      this.organizationInfo = organizationInfo;
    });
    this.observeConnectionLost();
  }

  observeConnectionLost(){
    this.connectionService.offlineStatus.subscribe(() =>{
      this.online = false;
    });
    this.connectionService.onlineStatus.subscribe(() =>{
      this.online = true;
    })
  }

  showNoInternetModal(){
    this.connectionService.showNoInternetWarning();
  }
}
